import React, { useEffect, useState } from "react";
import Button from "../../../../components/common/ui/Button";
import {
  RadioInput,
  SelectInput,
  TextInput,
} from "../../../../components/common/ui/Inputs";
import Table from "../../../../components/common/table/Table";
import { history } from "../../../../_helpers";
import { categoryActions } from "../../../../_store/category.slice";
import { useDispatch, useSelector } from "react-redux";
import ToggleSwitch from "../../../../components/common/ui/Inputs/ToggleSwitch";
import editIcon from "../../../../assets/svg/edit-icon.svg";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../../../components/common/ui/Loader";

const Category = () => {
  const [filterCategory, setFilterCategory] = useState({
    title: "",
    status: true,
  });

  const [apiParams, setApiParams] = useState(
    `?page=${1}&limit=${10}&status=${true}`
  );
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);

  const dispatch = useDispatch();

  const { ActiveStatus } = useSelector((x) => x?.dropDown);

  useEffect(() => {
    const params = apiParams;
    dispatch(categoryActions.getCategoryList(params));
  }, []);

  useEffect(() => {
    const query = new URLSearchParams({
      page: pageNo.toString(),
      limit: rowCountPerPage.toString(),
      ...Object.fromEntries(
        Object.entries(filterCategory).filter(([_, v]) => v !== "")
      ),
    }).toString();

    setApiParams(`?${query}`);
  }, [filterCategory, pageNo, rowCountPerPage]);

  const { categoryList, loading } = useSelector((x) => x.category);

  const list = categoryList?.data?.categories;
  const totalCount = categoryList?.data?.totalItems || 0;

  const columns = [
    {
      name: "Title",
      key: "title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleEditCategory(row);
            }}
          />

          <ToggleSwitch
            name={`Status${row._id}`}
            id={`Status${row._id}`}
            checked={row.status === true}
            value={row.status === true ? 1 : 0}
            handleClick={(e) => handleCategoryStatus(e, row)}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  const handleRowPerPage = (page) => {
    const updatedParams = apiParams.replace(/&limit=\d+/, `&limit=${page}`);
    setApiParams(updatedParams);
    dispatch(categoryActions?.getCategoryList(updatedParams));
    setRowCountPerPage(page);
    setPageNo(1);
  };

  const handlePageChange = (page) => {
    const updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    setApiParams(updatedParams);
    dispatch(categoryActions?.getCategoryList(updatedParams));
    setPageNo(page);
  };

  const handleEditCategory = (row) => {
    history?.navigate("/Admin/DocCategory/CreateOrEdit", {
      state: { categoryId: row?._id },
    });
  };

  const handleCategoryStatus = (e, row) => {
    dispatch(
      categoryActions.categoryStatusChange({
        id: row?._id,
      })
    )
      .then((result) => {
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          const params = apiParams;
          dispatch(categoryActions.getCategoryList(params));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to delete members", "error");
      });
  };

  const handleSearchChange = (e) => {
    debugger;
    const { name, value } = e.target;
    if (value.startsWith(" ")) return;
    if (name === "status") {
      //
      setFilterCategory((prev) => ({
        ...prev,
        [name]: value === "true" ? true : false,
      }));
    } else {
      setFilterCategory((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    setPageNo(1);
    setRowCountPerPage(10);
    dispatch(categoryActions.getCategoryList(apiParams));
  };
  const handleFormReset = () => {
    const params = `?page=${1}&limit=${10}&status=${true}`;
    setApiParams(params);
    setFilterCategory({ title: "", status: true });
    setPageNo(1);
    setRowCountPerPage(10);
    dispatch(categoryActions?.getCategoryList(params));
  };

  if (loading) return <CustomLoader />;
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">Documents Category</h1>
        <Button
          status="secondary"
          label="Create Documents Category"
          onClick={() => {
            history?.navigate("/Admin/DocCategory/CreateOrEdit", {
              state: { categoryId: 0 },
            });
          }}
        />
      </div>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
          Search Documents Category
        </h1>
        <form
          className="p-3 row"
          onSubmit={(e) => {
            handleSearchSubmit(e);
          }}
          onReset={(e) => {
            handleFormReset(e);
          }}
        >
          <div className="col-md-4">
            <TextInput
              label="Title"
              placeholder="Title"
              name="title"
              handleChange={handleSearchChange}
              value={filterCategory?.title}
            />
          </div>

          <div className="col-md-3">
            <RadioInput
              name="status"
              id="status"
              label="Status"
              options={ActiveStatus}
              handleChange={(e) => handleSearchChange(e)}
              selectedValue={filterCategory?.status}
              value={filterCategory?.status}
            />
          </div>

          <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
            <Button status="secondary" label="Search" type="submit" />
            <Button status="reset" label="Reset" type="reset" />
          </div>
        </form>
      </div>

      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color p-3 ">
          Documents Category List
        </h1>
        <Table
          columns={columns}
          data={list}
          pagination
          onChangeRowsPerPage={handleRowPerPage}
          onChangePage={handlePageChange}
          totalRowCount={totalCount}
          currentPage={pageNo}
          paginationPerPage={rowCountPerPage}
        />
      </div>
    </>
  );
};

export default Category;
